module.exports = __webpack_public_path__ + "img/21-min.5fea181b.jpg";